// extracted by mini-css-extract-plugin
export default {"root":"Spinner_root__2KcPy","small":"Spinner_small__ka4b-","spinner":"Spinner_spinner__MmUyt","transparent":"Spinner_transparent__AeSVa","spinnerFixed":"Spinner_spinnerFixed__uA7rR"};